import React, { useEffect, useState, useContext, useRef } from "react";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginBg from "../../images/newimg/login.jpg";
import PlaceholderImg from "../../images/placeholder.png";
import EditIcon from "../../images/edit.svg";
import SuccessIcon from "../../images/success.svg";
import Modal from "react-bootstrap/Modal";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import Calendar from "react-calendar";
import Functions from "../../../utility/services/Functions";
import { toast } from "react-toastify";
import { AuthContext } from "../../../utility/services/AuthContext";
import ConstConfig from "../../../utility/configs/constConfig";
import ApiService from "../../../utility/services/ApiService";
import Select from "react-dropdown-select";
import Otp_model_for_register from "../../common/components/Otp_model_for_register";
import heic2any from "heic2any";
import { trackScreenView, trackButtonClick, trackEvent } from "../../../utility/services/analyticsService";

const Patientregisteration = () => {
  // LOGICAL VARIABLES

  const errorStyle = {
    position: "relative",
    top: -10,
  };

  const location = useLocation();
  const navigate = useNavigate();

  let navigateFrom = location?.state?.navigateFrom || "";
  const isNavigateFromOptScreen = navigateFrom == "otp_screen";
  let phone = isNavigateFromOptScreen
    ? location?.state?.phone || ""
    : "";
  let socialData = !isNavigateFromOptScreen ? location.state?.socialData : {};
  const apple_id =
    Object.keys(socialData).length > 0 ? socialData.apple_id : "";
  const facebook_id =
    Object.keys(socialData).length > 0 ? socialData.facebook_id : "";

  const [modalShow, setModalShow] = React.useState(false);
  const [validationsRes, setValidationsRes] = useState({});
  const [showDateModel, setShowDateModel] = useState(false);
  const [statesList, setStatesList] = useState([]);
  const [imgPreview, setImgPreview] = useState("");
  const [submit, setSubmit] = useState(false);
  const [submitRes, setSubmitRes] = useState({});
  const [termsAndConditions, setTermsAndConditions] = useState(false);

  const [show_otp_modal, setShowOtpModal] = useState(false);
  const signupStartFired = useRef(false);

  const {
    consoleService,
    formetDate,
    calculateAge,
    enctyptDataFun,
    localDateFromString,
    split_simple_year_date_month_from_str,
    formatYMD,
    get_simple_year_date_month_str,
  } = Functions();
  const { get_states, register_user, check_user_role_auth, send_otp } =
    ApiService();
  const { setLoading, setUser, user, authUserRole } = useContext(AuthContext);

  // DATA VARIABLES

  const [custom_phone, setCustomPhone] = useState("");
  const [profile_img, setProfileImg] = useState("");
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("Male");
  const [email, setEmail] = useState(
    isNavigateFromOptScreen ? "" : socialData?.email
  );
  const [state, setState] = useState([]);

  // USE EFFECTS

  useEffect(() => {
    if (!navigateFrom)
      return navigate("/login", {
        replace: true,
      });
    trackScreenView("signup_screen", { screen_name: "Sign Up", user_type: "public", signup_type: "patient_signup" });
    fetch_lists();
  }, []);

  useEffect(() => {
    validationsResFun();
  }, [name, dob, gender, email, state, custom_phone]);

  // FUNCTIONS

  function validationsResFun() {
    setValidationsRes(
      ValidationsService({
        name,
        dob,
        phone: custom_phone,
        gender,
        email,
        state,
      })
    );
  }

  async function fetch_lists() {
    setLoading(true);
    try {
      const states_res = await get_states();
      if (states_res.status === 1) {
        const modified_states_list = states_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        setStatesList(modified_states_list);

        if (!isNavigateFromOptScreen) {
          if (
            socialData.loginType == "google" ||
            socialData.loginType == "facebook"
          ) {
            setName(socialData.name);
          }
        }
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch lists function = ", err);
    }
  }

  const select_profile_img = async (files) => {
    try {
      if (files.length > 0) {
        const file = files[0];
        const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
        const isMatch = file.type.match(imageTypeRegex);
        if (isMatch) {
          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
              });
              const convertedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              setImgPreview(URL.createObjectURL(convertedFile));
              setProfileImg(convertedFile);
            } catch (error) {
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              return;
            }
          } else {
            setImgPreview(URL.createObjectURL(file));
            setProfileImg(file);
          }
        } else {
          toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }
    } catch (err) {
      consoleService("error in select_profile_image =", err);
    }
  };

  const submitFun = async () => {
    trackButtonClick("signup_cta", {
      button_name: "Submit",
      screen_name: "Sign Up",
      signup_type: "patient_signup",
      user_name: name,
      email: email,
      phone: phone || (custom_phone ? `+1${custom_phone.trim()}` : ""),
    });
    if (!navigateFrom)
      return navigate("/login", {
        replace: true,
      });
    let ConditionCheck = false;
    const isCustomPhoneFound = custom_phone.trim() != "";
    const isNavigateFromOtpScreen = navigateFrom == "otp_screen";
    if (isNavigateFromOtpScreen) {
      if (phone) {
        ConditionCheck = true;
      } else {
        ConditionCheck = false;
      }
    } else {
      if (isCustomPhoneFound && validationsRes.phoneErr)
        return toast(validationsRes.phoneErr, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      ConditionCheck = true;
    }

    if (!(calculateAge(dob) >= 12))
      return toast("You must be above 12 years of age to register.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    setSubmit(true);
    if (
      !validationsRes.nameErr &&
      !validationsRes.dobErr &&
      !validationsRes.emailErr &&
      !validationsRes.stateErr &&
      termsAndConditions &&
      ConditionCheck
    ) {
      try {
        const isPhoneToUpdate = isNavigateFromOtpScreen
          ? false
          : isCustomPhoneFound
          ? true
          : false;
        if (isPhoneToUpdate) return setShowOtpModal(true);
        await register_function(phone);
      } catch (err) {
        setLoading(false);
        consoleService("Error in submit function = ", err);
      }
    } else {
      toast("Some fields are missing.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    }
  };

  const register_function = async (phone_no_to_update) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("first_name", name);
      formData.append("dob", dob);
      formData.append("email", email);
      formData.append("gender", gender);
      formData.append("state", state[0].value);
      formData.append("apple_id", apple_id);
      formData.append("facebook_id", facebook_id);
      formData.append("role", "Patient");
      formData.append("profile_img", profile_img);
      formData.append("phone", phone_no_to_update);
      formData.append("terms", termsAndConditions);
      const res = await register_user(formData);
      if (res.status === 1) {
        trackEvent("patient_registration", { event_type: "event", user_name: name, email: email, phone: phone_no_to_update });
        trackEvent("login", { event_type: "logged_in", method: "registration", user_role: "Patient", user_name: name, email: email });
        clearFields();
        setLoading(false);
        setSubmit(false);
        setSubmitRes(res);
        setModalShow(true);
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      consoleService("error in register_function ", err);
    }
  };

  function clearFields() {
    setName("");
    setDob("");
    setCustomPhone("");
    setGender("Male");
    setEmail("");
    setState("");
    setProfileImg("");
    setImgPreview([]);
    phone = "";
    navigateFrom = "";
  }

  const send_otp_function = async () => {
    setLoading(true);
    try {
      const modifiedPhone = `+1${custom_phone.trim()}`;

      const data = {
        role: authUserRole,
        phone: modifiedPhone,
      };
      const check_user_role_res = await check_user_role_auth(data);

      if (check_user_role_res.status === 1) {
        const res = await send_otp(data);

        if (res.status === 1) {
          navigate("/otp", {
            state: { phone: modifiedPhone },
          });
          setLoading(false);
        } else {
          toast(res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
          setLoading(false);
        }
      } else {
        toast(check_user_role_res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("error in send otp function", err);
    }
  };

  // NESTED COMPONENTS

  function Date_model(props) {
    const [selectedDate, setSelectedDate] = useState(
      dob
        ? new Date(
            localDateFromString(split_simple_year_date_month_from_str(dob))
          )
        : new Date(1940, 0, 1)
    );
    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setSelectedDate(new Date(dob));
          setShowDateModel(false);
        }}
      >
        <Modal.Body className="text-left">
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      setSelectedDate(new Date(date));
                    }}
                    value={selectedDate}
                    minDate={new Date(1940, 0, 1)}
                    maxDate={new Date()}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={(e) => {
              e.preventDefault();

              setDob(formatYMD(selectedDate));

              setShowDateModel(false);
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Success</h4>
          <p>Your account has been created successfully!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              localStorage.setItem(
                "E_C_U_A_T",
                enctyptDataFun(submitRes.data.token)
              );
              setUser({ ...user, access_token: submitRes.data.token });
              setSubmitRes({});
              navigate("/dashboard", { replace: true });
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // MAIN RETURN

  return (
    <section className="loginBg" style={{ backgroundImage: `url(${LoginBg})` }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Form>
              <div className="loginBox loginUpdateBox">
                <div className="userImg">
                  <Image
                    src={imgPreview ? imgPreview : PlaceholderImg}
                    className="userImage"
                    alt=""
                  />
                  <div>
                    <Image src={EditIcon} className="editIcon" alt="" />
                    <input
                      type="file"
                      accept="image/jpg, image/jpeg, image/png, image/heic"
                      className="edit_img"
                      multiple={false}
                      onChange={(e) => {
                        select_profile_img(e.target.files);
                      }}
                    />
                  </div>
                </div>
                <Form.Control
                  type="text"
                  placeholder="Your Name"
                  value={name}
                  onFocus={() => {
                    if (!signupStartFired.current) {
                      signupStartFired.current = true;
                      trackEvent("signup_start");
                    }
                  }}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
                {submit && validationsRes.nameErr && (
                  <span className="validations_err" style={errorStyle}>
                    {validationsRes.nameErr}
                  </span>
                )}
                <Form.Control
                  className="mb-3"
                  type="text"
                  placeholder="D.O.B."
                  value={dob && get_simple_year_date_month_str(dob)}
                  onClick={() => {
                    setShowDateModel(true);
                  }}
                />
                {!submit && !validationsRes.dobErr && (
                  <small>You must be above 12 years of age to register</small>
                )}
                {submit && validationsRes.dobErr && (
                  <span className="validations_err" style={errorStyle}>
                    {validationsRes.dobErr}
                  </span>
                )}
                <Form.Control
                  type="text"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => {
                    (isNavigateFromOptScreen || apple_id.trim()) &&
                      setEmail(e.target.value);
                  }}
                />
                {submit && validationsRes.emailErr && (
                  <span className="validations_err" style={errorStyle}>
                    {validationsRes.emailErr}
                  </span>
                )}

                {!phone && (
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput2"
                  >
                    {/* <Form.Label>Phone Number</Form.Label> */}
                    <div className="pbox register_pb_box">
                      <div className="callb">
                        US{" "}
                        <svg
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                          x
                        >
                          <path
                            d="M1 1.5L6 6.5L11 1.5"
                            stroke="#212529"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span
                          style={{
                            color: !custom_phone.trim() ? "#929fa4" : null,
                          }}
                        >
                          +1
                        </span>
                      </div>
                      <Form.Control
                        type="text"
                        className="register_phone_input"
                        value={custom_phone}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setCustomPhone(numericValue);
                        }}
                        onKeyDown={(e) => {
                          if (e.key == "Enter") {
                            e.preventDefault();
                            // !validationsRes.phoneErr && send_otp_function();
                          }
                        }}
                        placeholder="(555) 000-0000"
                      />
                    </div>
                  </Form.Group>
                )}
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput3"
                >
                  <Select
                    placeholder={"Select State"}
                    options={statesList}
                    values={state}
                    onChange={(value) => {
                      setState(value);
                    }}
                  />
                </Form.Group>
                {submit && validationsRes.stateErr && (
                  <span className="validations_err" style={errorStyle}>
                    {validationsRes.stateErr}
                  </span>
                )}

                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput3"
                >
                  <Form.Label>What is your gender?</Form.Label>
                  {["radio"].map((type) => (
                    <div key={`default-${type}`} className="boxFlex">
                      <Form.Check // prettier-ignore
                        type={type}
                        id="g1"
                        label="Male"
                        name="gender"
                        checked={gender == "Male"}
                        onClick={() => {
                          setGender("Male");
                        }}
                      />
                      <Form.Check // prettier-ignore
                        type={type}
                        id="g2"
                        label="Female"
                        name="gender"
                        checked={gender == "Female"}
                        onClick={() => {
                          setGender("Female");
                        }}
                      />
                      <Form.Check // prettier-ignore
                        type={type}
                        id="g3"
                        label="Unspecified"
                        name="gender"
                        checked={gender == "Unspecified"}
                        onClick={() => {
                          setGender("Unspecified");
                        }}
                      />
                    </div>
                  ))}
                </Form.Group>

                <Form.Group
                  className="mb-4"
                  controlId="exampleForm.ControlInput3"
                >
                  <Form.Label>HIPAA Compliance</Form.Label>
                  {["checkbox"].map((type) => (
                    <div key={`default-${type}`} className="mb-3 termBox">
                      <Form.Check // prettier-ignore
                        type={type}
                        id="1"
                        checked={termsAndConditions}
                        label={
                          <span>
                            I accept the{" "}
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                window.open("/termsofservice");
                              }}
                              className="linkhip"
                            >
                              terms and conditions
                            </Link>
                            {" - "}
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                window.open("/hipaa");
                              }}
                              className="linkhip"
                            >
                              HIPAA
                            </Link>{" "}
                            while sharing my health details
                          </span>
                        }
                        onClick={() => {
                          setTermsAndConditions(!termsAndConditions);
                        }}
                      />
                    </div>
                  ))}
                </Form.Group>
                <Button
                  disabled={!termsAndConditions}
                  onClick={() => submitFun()}
                  className="btn btn-primary me-3"
                >
                  Submit
                </Button>
              </div>
            </Form>
            <MyVerticallyCenteredModal show={modalShow} />
          </div>
        </div>
      </div>
      {show_otp_modal && (
        <Otp_model_for_register
          show={true}
          onHide={() => {
            setShowOtpModal(false);
          }}
          verify_type="update_profile"
          phone_number={custom_phone}
          register_function={register_function}
        />
      )}
      <Date_model show={showDateModel} />
    </section>
  );
};

export default Patientregisteration;
